// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__oqcyK","messages":"Chat_messages__2jXAH","dateDivider":"Chat_dateDivider__2XUTG"};